module.exports = __webpack_public_path__ + "static/media/5.1_preview.dc4398a2.png";